import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RegistriesService} from '../../service';
import {AccessJson, FromuFilter} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {AlertPanelComponent, AlertService} from '@amlCore/components';
import {IFromuInfoItem} from '../../model';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {Utils} from '@amlCore/utils';
import {IDataResponse} from '@amlCore/interfaces';
import {
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';

@Component({
  selector: 'app-registry-fromu-info-list',
  templateUrl: './fromuInfoList.component.html'
})
export class FromuInfoListComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  isAll = false;
  loadCheckList = {};
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private readonly regSrv: RegistriesService,
              private readonly userSrv: UserService,
              protected readonly alertSrv: AlertService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router) {
    super(router, activatedRoute, visitedService, tableService, { sort: 'sysRegData', dir: 'DESC'});
  }

  public dataList: IFromuInfoItem[] = [];
  public access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_FROMU);
    this.activatedRoute.queryParams.subscribe((data: FromuFilter) => {
      this.loadList(this.syncParams(data));
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data): FromuFilter {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter) as FromuFilter;
  }

  public onPageChange(params: FromuFilter) {
    this.navigate({...params, ...this.getParams(this.filter)});
  }

  private customSearch() {
    const params = this.getSearchPage(this.filter) as FromuFilter;
    params['dir'] = 'ASC';
    params['sort'] = 'name';
    params['isAll'] = true;
    const urlParam = {};
    for (const key in params) {
      if (params[key] || typeof params[key] === "number") {
        urlParam[key] = params[key];
      }
    }
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigateByUrl('registries/fromuList?q=' + Utils.encodeJSONBase64(urlParam));
  }

  // @override
  public onSearch() {
    this.customSearch();
  }

  // @override
  public onFilter() {
    this.customSearch();
  }

  public loadList(params?: FromuFilter) {
    const queryParams = this.getParams(params);
    this.regSrv.getFromuFullInfoList(queryParams).subscribe((data: IDataResponse<IFromuInfoItem>) => {
      this.dataList = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  public showSubjList(item: IFromuInfoItem) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/fromuList', item.id]);
  }

  public remove($event, item: IFromuInfoItem) {
    this.alertSrv.clear();
    this.regSrv.removeFile('/api/v1/qref/fromu/remove', {id: item.id}).subscribe(data => {
      this.alertSrv.success(`Запись ${item.fileName} удалена!`);
      this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  public checkRiskFactor(item: IFromuInfoItem) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.FROMU, this.loadCheckList, this.alertObjToCheck);
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }

}
